import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { PricingDetailModal } from './PricingDetailModal';
const blocks = [{
  key: 'presencia',
  name: 'PRESENCIA DIGITAL',
  setup: '$3.500.000',
  setupNote: 'implementación',
  monthly: '$250.000/mes',
  note: 'Mantenimiento opcional.',
  featured: false
}, {
  key: 'comercial',
  name: 'SISTEMA COMERCIAL',
  setup: 'Desde $2.500.000',
  setupNote: 'implementación',
  monthly: 'Desde $650.000/mes',
  note: 'IA + WhatsApp + CRM + agenda + seguimiento.',
  featured: false
}, {
  key: 'completo',
  name: 'SISTEMA COMPLETO',
  setup: 'Desde $6.000.000',
  setupNote: 'implementación',
  monthly: 'Desde $900.000/mes',
  note: 'Presencia digital + sistema comercial.',
  featured: true
}];
const whyOrigen = [{
  title: 'SISTEMAS',
  desc: 'Diseñamos cómo las herramientas trabajan juntas.'
}, {
  title: 'IA CON PROPÓSITO',
  desc: 'Automatizamos procesos concretos. No agregamos IA por moda.'
}, {
  title: 'EVOLUCIÓN',
  desc: 'Construimos sistemas que pueden crecer contigo.'
}];
const applications = [{
  sector: 'CLÍNICAS',
  flow: 'WhatsApp → IA → Calificación → Agenda → Seguimiento'
}, {
  sector: 'INMOBILIARIAS',
  flow: 'Consulta → Propiedad → Calificación → Visita → CRM'
}, {
  sector: 'SERVICIOS',
  flow: 'Solicitud → IA → Información → Cotización → Seguimiento'
}, {
  sector: 'EDUCACIÓN',
  flow: 'Interés → Programa → Calificación → Asesor → Matrícula'
}, {
  sector: 'E-COMMERCE',
  flow: 'Producto → Consulta → IA → Compra → Postventa'
}, {
  sector: 'EMPRESAS',
  flow: 'Lead → IA → CRM → Reunión → Seguimiento'
}];
export function Pricing() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="precios" className="bg-arena py-[72px] md:py-[120px]" data-id="element-118" data-mp="3eyl21918vjke">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-119" data-mp="3jw3209xaaog9">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 text-center max-w-[600px] mx-auto" data-id="element-120" data-mp="3jyp968g9j1xy">
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-carbon leading-[1.1]" data-id="element-121" data-mp="104417t407ga9">
            Empieza donde lo necesita tu empresa.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch mb-8" data-id="element-122" data-mp="19zfgqdn8krj2">
          {blocks.map((block, idx) => <motion.div key={block.key} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: idx * 0.08
        }} className={`flex flex-col rounded-[12px] p-8 transition-all duration-200 ${block.featured ? 'bg-verde text-arena md:-translate-y-2 shadow-cta border border-verde' : 'bg-arena-dark text-carbon border border-salvia/25'}`} data-id="element-123" data-mp="14zt0rwg0wx6k" data-mpi={idx}>
              <span className={`font-body text-[11px] uppercase tracking-[0.12em] mb-5 ${block.featured ? 'text-arena/60' : 'text-salvia'}`} data-id="element-124" data-mp="2cb72k0n2hlqa">
                {block.name}
              </span>
              <div className="mb-4" data-id="element-125" data-mp="1onz1juwo8yu2">
                <div className="flex items-baseline gap-1.5" data-id="element-126" data-mp="1omxdmpuk4hux">
                  <span className={`font-display text-[24px] font-bold ${block.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-127" data-mp="1te5ozrfg6daq">
                    {block.setup}
                  </span>
                </div>
                <span className={`font-body text-[12px] ${block.featured ? 'text-arena/60' : 'text-carbon/50'}`} data-id="element-128" data-mp="1jpdx1jadzszt">
                  {block.setupNote}
                </span>
              </div>
              <span className={`font-display text-[16px] font-semibold mb-5 ${block.featured ? 'text-arena' : 'text-carbon'}`} data-id="element-129" data-mp="19sizp3punyn4">
                {block.monthly}
              </span>
              <div className={`h-px w-full mb-4 ${block.featured ? 'bg-arena/20' : 'bg-carbon/10'}`} data-id="element-130" data-mp="sxf6vafiauh3" />
              <p className={`font-body text-[14px] leading-[1.5] ${block.featured ? 'text-arena/80' : 'text-carbon/60'}`} data-id="element-131" data-mp="nz3vgv9kcbwr">
                {block.note}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="text-center mb-20 md:mb-24" data-id="element-132" data-mp="ezqme3pcppck">
          <p className="font-body text-[14px] text-carbon/50 mb-3" data-id="element-133" data-mp="24biy48upm4ig">
            ¿Quieres conocer todas las configuraciones?
          </p>
          <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center gap-1.5 font-display text-[14px] font-semibold text-verde hover:gap-2.5 transition-all duration-200" data-id="element-134" data-mp="1zbeg2ee5l1q4">
            Ver alcance detallado <ArrowRight size={15} data-id="element-135" data-mp="2gmjr1snyf8o5" />
          </button>
        </motion.div>

        {/* Why ORIGEN */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16 md:mb-20" data-id="element-136" data-mp="2lm63w0zvemwf">
          <h3 className="font-display text-[24px] md:text-[32px] font-bold text-carbon text-center mb-10" data-id="element-137" data-mp="1xwbr1jfjwyc6">
            Construimos sistemas, no herramientas.
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-138" data-mp="22wq2lbgd2qey">
            {whyOrigen.map(item => <div key={item.title} className="text-center md:text-left" data-id="element-139" data-mp="39dlai5yojqdh">
                <span className="block font-body text-[12px] uppercase tracking-[0.1em] text-salvia mb-2" data-id="element-140" data-mp="3e9afwpxds1hp">
                  {item.title}
                </span>
                <p className="font-body text-[15px] text-carbon/65 leading-[1.6]" data-id="element-141" data-mp="2jnuz9fihql09">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </motion.div>

        {/* Applications */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-142" data-mp="2tmuan5un4uqy">
          <h3 className="font-display text-[24px] md:text-[32px] font-bold text-carbon text-center mb-3" data-id="element-143" data-mp="20yol85sn6hks">
            Una arquitectura. Diferentes empresas.
          </h3>
          <p className="text-center font-body text-[13px] text-carbon/40 italic mb-10" data-id="element-144" data-mp="2au9kvxa8n5rd">
            Escenarios de aplicación — no casos reales ni testimonios.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-145" data-mp="1i6vw4mgp1gic">
            {applications.map(app => <div key={app.sector} className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-4 bg-arena-dark border border-carbon/10 rounded-[12px] px-5 py-4" data-id="element-146" data-mp="3ttfs648k8yps">
                <span className="font-body text-[12px] font-semibold uppercase tracking-[0.08em] text-carbon/70 sm:w-[140px] flex-shrink-0" data-id="element-147" data-mp="3jwumdgopvjkw">
                  {app.sector}
                </span>
                <span className="font-body text-[13px] text-carbon/55" data-id="element-148" data-mp="gg4f6yhef0hm">
                  {app.flow}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>

      <PricingDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-149" data-mp="7dd2ywgp80ox" />
    </section>;
}